import React from "react";
import { DropdownSelector } from "@Modules/common/Form";
import { AiFillMinusCircle } from "@react-icons/all-files/ai/AiFillMinusCircle";
import { ISlots } from "./ISlots";
import styles from "../../slotDropdown.module.scss";
import useSlotsData from "./useSlotsData";

const Slot = (props: ISlots.IProps) => {
    const {
        slotDateValue,
        slotTimeValue,
        slotDateOptions,
        slotTimeOptions,
        disableEditing,
        isOptionDisabled,
        handleDateChange,
        handleSlotChange,
        ticketCount,
        removeSlot,
        index,
    } = useSlotsData(props);

    return (
        <div
            className={styles.slotRow}
            key={`${slotDateValue?.value} - ${slotTimeValue?.value}`}
        >
            <DropdownSelector
                className={styles.dropdownDate}
                id={`slotDropdown-slotDate-${index}`}
                onChange={handleDateChange}
                value={slotDateValue}
                placeholder="Select date"
                options={slotDateOptions}
                autoSelect="FIOOO"
                isSearchable={false}
            />

            <DropdownSelector
                className={styles.dropdownTime}
                id={`slotDropdown-slotTime-${index}`}
                onChange={handleSlotChange}
                editingDisabled={disableEditing}
                value={slotTimeValue}
                placeholder="Select time"
                options={slotTimeOptions}
                autoSelect="FIOOO"
                isSearchable={false}
                isOptionDisabled={isOptionDisabled}
            />
            {ticketCount > 1 ? (
                <div
                    className={styles.removeSlot}
                    title="Remove Slot"
                    onClick={removeSlot(index)}
                >
                    <AiFillMinusCircle className={styles.removeIcon} />
                </div>
            ) : null}
        </div>
    );
};

export default Slot;
